/* eslint-disable indent */
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import colors from "../../theme/themeConstants";

interface IProps {
  currentStep: number;
  stepsCount: number;
  isAuthProgress?: boolean;
}

export default function HorizontalLabelPositionBelowStepper(props: IProps) {
  const { currentStep, stepsCount, isAuthProgress } = props;

  const steps = new Array<string>(stepsCount).fill("");

  return (
    <Box sx={{ width: "100%" }} className={isAuthProgress ? "isAuthProgress" : ""}>
      <Stepper
        activeStep={currentStep}
        sx={{
          "& .Mui-active .MuiStepConnector-line": {
            borderColor: colors.redPink,
          },
          "& .Mui-completed .MuiStepConnector-line": {
            borderColor: colors.redPink,
          },
          "& .Mui-disabled .MuiStepConnector-line": {
            borderColor: colors.lightGrayPaperBackground,
          },
          "& .MuiStepConnector-line": {
            borderTopWidth: "2px",
            borderColor: "rgba(15, 15, 55, .2)",
          },
          "& .MuiStepLabel": {
            display: "none"
          },
          "& .MuiStepLabel-iconContainer:not(.Mui-active)": {
            padding: 0
          },
          "& .MuiStep-root.Mui-completed, & .Mui-disabled + div": {
            display: "none"
          }
        }}
      >
        {steps.map((label, index) => (
          <Step
            key={index}
            sx={{
              "& svg": {
                position: "relative",
                left: "4px",
                width: "6px",
                height: "6px",
                background: "linear-gradient(0deg, rgba(216, 223, 236, 0.5), rgba(216, 223, 236, 0.5)), #0B0B28",
                borderRadius: "50%",
                transitionDuration: "0.3s"
              },
              "& .MuiStepIcon-root.Mui-completed": {
                color: colors.redPink,
              },
              "& .MuiStepIcon-root.Mui-active": {
                width: "10px",
                height: "10px",
                color: colors.redPink,
                position: "relative",
                top: "0px"
              },
              "& .MuiStepIcon-text": {
                fill: "transparent"
              },
              "& path": {
                stroke: colors.redPink,
                strokeWidth: "6px"
              },
              "&.MuiStep-root": {
                padding: 0
              }
            }}
          >
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}
